import React from 'react'

const FeedStack = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <g>
      <g transform="translate(-1034 -774)">
        <g transform="translate(1008 756)">
          <g id="list" transform="translate(0 8)">
            <g transform="translate(30 12.5)">
              <path d="M-3.1 10.8h26.6c.5 0 .9.4.9.9s-.4.9-.9.9H-3.1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9z" />
              <path d="M-3.1 1.9h26.6c.5 0 .9.4.9.9s-.4.9-.9.9H-3.1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9z" />
              <path d="M-3.1 19.6h26.6c.5 0 .9.4.9.9s-.4.9-.9.9H-3.1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default FeedStack
